import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import CardContent from '@mui/material/CardContent';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';

/** MyMine Version2.0 DigitalSolutionLv3画面新規追加
* DigitalSolutionLv3 Page Content
*/
export const DigitalSolutionLv3 = () => {
  const SolutionPanel = (props) => {
    const { imagePath, nameLabel, descriptionLabel1, descriptionLabel2, descriptionLabel3 } = props;
    return (
      <Grid item xs={12} md={12} lg={4}>
      {/*2025.7.7 MyMine Version3.0対応 Modify Start*/}
        {imagePath && nameLabel &&
          <OutlinedCustomCard>
            <Box sx={{ height: '350px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <MyMImage screenId={screenId} filePath={imagePath} width='100%' height='100%' style={{ objectFit: 'contain' }} />
            </Box>
            <Box sx={{ minHeight: '50px', display: 'flex', alignItems: 'center' }}>
              <MyMLabel fontSize='1.2rem' fontWeight='bold' sx={{ position: 'relative', ml: 'auto', mr: 'auto' }}>{nameLabel}</MyMLabel>
            </Box>
            <Box sx={{ p: 1, marginTop: '3px', borderBottom: '2px solid grey', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            </Box>
            <CardContent>
              <Grid container>
                <Grid item xs={1}>
                  <MyMLabel fontSize='1.2rem'>・</MyMLabel>
                </Grid>
                <Grid item xs={11}>
                  <MyMLabel fontSize='1.2rem'>{descriptionLabel1}</MyMLabel>
                </Grid>
                <Grid item xs={1}>
                  <MyMLabel fontSize='1.2rem'>・</MyMLabel>
                </Grid>
                <Grid item xs={11}>
                  <MyMLabel fontSize='1.2rem'>{descriptionLabel2}</MyMLabel>
                </Grid>
                <Grid item xs={1}>
                  <MyMLabel fontSize='1.2rem'>・</MyMLabel>
                </Grid>
                <Grid item xs={11}>
                  <MyMLabel fontSize='1.2rem'>{descriptionLabel3}</MyMLabel>
                </Grid>
              </Grid>
            </CardContent>
          </OutlinedCustomCard>
        }
        {/*2025.7.7 MyMine Version3.0対応 Modify End*/}
      </Grid>
    );
  }
  const screenId = 'MyM312';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const queryParam = useParams();
  const [isInitLoading, setIsInitLoading] = useState(true);
  const solutionName = queryParam.solution_name_lv3.replaceAll(' ', '');
  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);
    apiRequest.requestJson('api/digital-solution/lv3', 'GET', endLoading, endLoading);
  }, [])

  if (isInitLoading)
    return <MyMProgress />

  return (
    <Grid container className='pb-4'>
      <Grid container>
        <Grid item xs={12} m={1}>
          <MyMVariantLabel variant='h5'>{controlSettings.LabelList[`lbl${solutionName}Header`]}</MyMVariantLabel>
          {controlSettings.LabelList[`lbl${solutionName}Description`]}
        </Grid>
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={10} >
        <Grid container direction="row" spacing={2} sx={{
          marginBottom: '30px'
        }}>
          {[...Array(9)].map((_, index) => (
            <SolutionPanel
              key={index + 1}
              imagePath={controlSettings.ImageList[`img${solutionName}${index + 1}`]}
              nameLabel={controlSettings.LabelList[`lbl${solutionName}Name${index + 1}`]}
              descriptionLabel1={controlSettings.LabelList[`lbl${solutionName}Description${index + 1}_1`]}
              descriptionLabel2={controlSettings.LabelList[`lbl${solutionName}Description${index + 1}_2`]}
              descriptionLabel3={controlSettings.LabelList[`lbl${solutionName}Description${index + 1}_3`]}
            />
          ))}
        </Grid >
      </Grid >
      <Grid item xs={1} />
    </Grid >
  );
}

export default DigitalSolutionLv3;